import { render, staticRenderFns } from "./IcpConfirmationModal.vue?vue&type=template&id=3cae1086"
import script from "./IcpConfirmationModal.vue?vue&type=script&lang=js"
export * from "./IcpConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports